/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'phone': {
    width: 10,
    height: 12,
    viewBox: '0 0 10 12',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M2.155 0h5.69C8.74 0 9.5.733 9.5 1.6v8.8c0 .867-.759 1.6-1.655 1.6h-5.69C1.26 12 .5 11.267.5 10.4V1.6C.5.733 1.259 0 2.155 0zm2.862 10.433c.207 0 .414.2.414.4 0 .234-.207.434-.414.434a.45.45 0 01-.448-.434c0-.2.207-.4.448-.4zM2.155.567h5.69c.586 0 1.069.466 1.069 1.033v8.167H1.086V1.6c0-.567.483-1.033 1.07-1.033z" _fill="#1988EF"/>'
  }
})
